import { useContextStore } from '@/stores/context'
import { useManagedAccountStore } from '@/stores/managed-account'

export function useSearchPermissions() {
  const userAccountContext = useContextStore(
    (state) => state.userAccountContext,
  )

  const isAdmin =
    userAccountContext?.userAccountInformation.role === 'Administrator'
  const isManaging = useManagedAccountStore((state) => state.isManaging)
  const isManaged = userAccountContext?.accountInformation.isManaged ?? false

  return { isAdmin, isManaged, isManaging }
}
